import React, { useState, useEffect } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

const HeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <section
      id="home"
      className="bg-gray-900 text-white h-screen flex items-center justify-center relative overflow-hidden"
    >
      <Carousel
        showThumbs={false}
        showStatus={false}
        infiniteLoop
        autoPlay
        interval={4000}
        className="w-full h-full"
      >
        <div className="relative h-full">
          <video autoPlay loop muted className="w-full h-full object-cover">
          <source src="/videos/video1.mp4" type="video/mp4" />
            Seu navegador não suporta o elemento de vídeo.
          </video>
          <div
            className={`absolute text-center w-full top-1/3 px-4 md:px-0 transition-opacity duration-1000 ${
              isVisible ? "opacity-100" : "opacity-0"
            }`}
          >
            <h1 className="text-4xl md:text-6xl font-extrabold mb-4 animate-text-pop-up">
              Bem-vindo à Uniconn Sistemas
            </h1>
            <p className="text-lg md:text-xl mb-8">
              Seu parceiro em soluções inovadoras de software.
            </p>
            <a
              href="#services"
              className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 md:py-3 md:px-6 rounded-full shadow-lg transform transition duration-500 hover:scale-105"
            >
              Saiba Mais
            </a>
          </div>
        </div>
        <div className="relative h-full">
          <video autoPlay loop muted className="w-full h-full object-cover">
          <source src="/videos/video2.mp4" type="video/mp4" />
            Seu navegador não suporta o elemento de vídeo.
          </video>
          <div className="absolute inset-0 flex items-center justify-center text-center p-4 bg-black bg-opacity-50">
            <p className="text-sm md:text-xl lg:text-3xl font-bold text-yellow-400">
              Nossa equipe de design <br className="md:hidden" /> é{" "}
              <span className="text-white">incrivelmente criativa</span> e{" "}
              <span className="text-white">altamente qualificada</span>. <br />
              Criamos experiências visuais que encantam e envolvem.
            </p>{" "}
          </div>
        </div>
        <div className="relative h-full">
          <video autoPlay loop muted className="w-full h-full object-cover">
          <source src="/videos/video3.mp4" type="video/mp4" />
            Seu navegador não suporta o elemento de vídeo.
          </video>
          <div className="absolute inset-0 flex items-center justify-center text-center p-4 bg-black bg-opacity-50">
            <p className="text-sm md:text-xl lg:text-3xl font-bold text-yellow-400">
              Sempre em busca das{" "}
              <span className="text-white">melhores tecnologias</span> para{" "}
              <span className="text-white">inovar</span> e{" "}
              <span className="text-white">superar expectativas</span>.
              <br /> Transformamos ideias em realidade.
            </p>
          </div>
        </div>
        <div className="relative h-full">
          <video autoPlay loop muted className="w-full h-full object-cover">
          <source src="/videos/video4.mp4" type="video/mp4" />
            Seu navegador não suporta o elemento de vídeo.
          </video>
          <div className="absolute inset-0 flex items-center justify-center text-center p-4 bg-black bg-opacity-50">
            <p className="text-sm md:text-xl lg:text-3xl font-bold text-yellow-400">
              Nossa equipe de suporte está{" "}
              <span className="text-white">disponível</span> para{" "}
              <span className="text-white">atender</span> e{" "}
              <span className="text-white">solucionar</span> qualquer desafio.
              <br /> Estamos aqui para você, sempre.
            </p>
          </div>
        </div>
        <div className="relative h-full">
          <video autoPlay loop muted className="w-full h-full object-cover">
          <source src="/videos/video5.mp4" type="video/mp4" />
            Seu navegador não suporta o elemento de vídeo.
          </video>
          <div className="absolute inset-0 flex items-center justify-center text-center p-4 bg-black bg-opacity-50">
            <p className="text-sm md:text-xl lg:text-3xl font-bold text-yellow-400">
              Nossa equipe é{" "}
              <span className="text-white">altamente qualificada</span> e{" "}
              <span className="text-white">dedicada</span> a entregar{" "}
              <span className="text-white">excelência</span>.
              <br /> Confiabilidade e expertise em cada projeto.
            </p>
          </div>
        </div>
      </Carousel>
    </section>
  );
};

export default HeroSection;
